import React from 'react';
import classNames from 'classnames';
import * as styles from '../Form.module.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
  hasPadding?: boolean;
};

export const FormContainer = ({ className, children, hasPadding }: Props) => {
  return (
    <div
      className={classNames(
        styles.FormContainer,
        { [styles.hasPadding]: hasPadding },
        className
      )}
    >
      {children}
    </div>
  );
};
